export const SET_MATCHED_PHOTO_BACKGROUND =
  'matched-photos/SET_MATCHED_PHOTO_BACKGROUND';
export const RESET_MATCHED_PHOTO_BACKGROUNDS =
  'matched-photos/RESET_MATCHED_PHOTO_BACKGROUNDS';

export const setMatchedPhotoBackground = ({
  matchedPhotoId,
  printBackgroundId,
}) => {
  return {
    type: SET_MATCHED_PHOTO_BACKGROUND,
    matchedPhotoId,
    printBackgroundId,
  };
};

export const resetMatchedPhotoBackgrounds = () => {
  return { type: RESET_MATCHED_PHOTO_BACKGROUNDS };
};
